import * as React from 'react'
import Confetti from 'react-confetti';

import useModalAccessibility from '../../../../../Shared/hooks/useModalAccessibility'
import useWindowSize from '../../../../../Shared/hooks/useWindowSize';

const illustrationSrc = `${window.postbuildEnv.CDN_URL}/images/pages/onboarding_slides/shared/child_raising_pencil.svg`

interface FreeMonthModalProps {
  closeModal: any,
}

const FreeMonthModal = ({ closeModal, }: FreeMonthModalProps) => {
  const { modalRef } = useModalAccessibility(closeModal);
  const { height, width, } = useWindowSize();

  return (
    <React.Fragment>
      <Confetti
        height={height}
        numberOfPieces={700}
        recycle={false}
        width={width}
      />
      <div
        aria-labelledby='title'
        aria-live="polite"
        aria-modal={true}
        className="modal-container free-month-modal-container"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="modal-background" />
        <div className="quill-modal modal-body free-month-modal">
          <img alt="" src={illustrationSrc} />
          <h1 id="title">You’ve unlocked a free month of Teacher Premium!</h1>
          <p>Go to your “My Subscriptions” page when you are ready to activate it.</p>
          <a className="quill-button medium contained gold focus-on-light" href="/finish_sign_up">Got it</a>
        </div>
      </div>
    </React.Fragment>
  )
}

export default FreeMonthModal
